import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import "./assets/fonts/pptelegraf/PPTelegraf-Regular.otf"
import '@fortawesome/fontawesome-free/css/all.min.css';
import './assets/styles/game.css'
import AuthProvider from './providers/AuthProvider';
import { GameProvider } from './components/newgame/context/GameContext';
import MasterProvider from './providers/MasterProvider';
import LanguageProvider from './providers/LanguageProvider';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <LanguageProvider>
      <AuthProvider>
        <MasterProvider>
        <GameProvider>
        {/* <DndProvider backend={HTML5Backend}> */}
        <App />
        {/* </DndProvider> */}
        </GameProvider>
        </MasterProvider>
      </AuthProvider>
      </LanguageProvider>
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
